import { render } from "./EditCategoryModal.vue?vue&type=template&id=36fa2e88&scoped=true"
import script from "./EditCategoryModal.vue?vue&type=script&lang=js"
export * from "./EditCategoryModal.vue?vue&type=script&lang=js"

import "./EditCategoryModal.vue?vue&type=style&index=0&id=36fa2e88&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36fa2e88"]])

export default __exports__